module.exports = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g fill=\"#152B4D\" fill-rule=\"evenodd\">\n    <path d=\"M10.333.666l1.415 1.415L6.08 7.748 4.668 6.333z\"/>\n    <path d=\"M.18 1.903L1.595.488 7.26 6.155 5.848 7.57z\"/>\n  </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/arrow-down-thick-sm.svg
// module id = 774
// module chunks = 1